import React, { useEffect, useState } from "react";
import Topnav from "../../components/topnav/topnav";
import { useLocation, useNavigate } from "react-router-dom";
import back from "../../assets/back.svg";
import { TableContainer } from "../../components/tables/currentOrdersViewTable";
import { notificationList } from "../../redux/actions/notification-actions";
import { useDispatch } from "react-redux";
import NumberPagination from "../../components/Pagination/number-pagination";
import moment from "moment";
import UploadInvoiceTableModal from "../../components/modals/uploadInvoiceTableModal";

const Notification = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const [page, setPage] = useState(page_no ?? 1);
  const [notificationData, setNotificationData] = useState([]);
  const [selectedOrder, setOrderSelected] = useState(null);
  const [showUploadInvoiceModal, setShowUploadInvoiceModal] = useState(false);

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    dispatch(notificationList({ search: "", page: page }, onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    console.log(data.data.data, "data");
    setNotificationData(data?.data?.data);
  };
  const onError = () => {};

  const queryParams = [];
  // if (search) queryParams.push(`search=${search}`);
  // if (filterdData?.status) queryParams.push(`status=${filterdData?.status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <main>
      <Topnav />

      <UploadInvoiceTableModal
        handleClose={() => setShowUploadInvoiceModal(false)}
        show={showUploadInvoiceModal}
        id={selectedOrder}
      />
      <div
        className="d-flex align-items-center p-2 ms-3 m-1 mb-2"
        onClick={() => navigate("/current-orders")}
      >
        <img src={back} alt="back_btn" />
        <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600 cursor_pointer">
          BACK
        </span>
      </div>
      <div className="p-2 mx-3 m-1 mb-2">
        <p className="fs_16 fw_700 text-uppercase color_747f9e">
          Notifications
        </p>
        <div>
          <TableContainer maxWidth={"100%"} height={"26rem"}>
            <table className="main-table fs_10 text-nowrap">
              <thead>
                <tr className="table-rows">
                  <th className="main-table-heads py-2" width={"2%"}>
                    #
                  </th>
                  <th className="main-table-heads py-2" width={"7%"}>
                    Order ID
                  </th>
                  <th
                    className="main-table-heads text-nowrap py-2"
                    width={"9%"}
                  >
                    Order Date and Time
                  </th>
                  <th
                    className="main-table-heads text-nowrap py-2"
                    width={"10%"}
                  >
                    Doctor Name
                  </th>
                  <th className="main-table-heads text-nowrap" width={"10%"}>
                    Pharmacy Name
                  </th>
                  <th
                    className="main-table-heads text-nowrap py-2"
                    width={"10%"}
                  >
                    Company Name
                  </th>
                  <th
                    className="main-table-heads text-nowrap py-2"
                    width={"10%"}
                  >
                    Reason
                  </th>

                  <th
                    className="main-table-heads text-nowrap py-2"
                    width={"10%"}
                  >
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody style={{ position: "relative" }}>
                {notificationData?.invoices?.map((item, index) => (
                  <tr className="table-rows1" key={item.id}>
                    <td className="main-table-each-row-data">{index + 1}</td>
                    <td className="main-table-each-row-data">
                      {item?.order?.order_id ?? "--"}
                    </td>
                    <td className="main-table-each-row-data">
                      {moment(item?.createdAt).format("DD MMM YYYY, HH:mm A")}
                    </td>
                    <td className="main-table-each-row-data">
                      {item?.doctor?.name ?? "--"}
                    </td>
                    <td className="main-table-each-row-data">
                      {item?.pharmacy?.pharmacy_name ?? "--"}
                    </td>
                    <td className="main-table-each-row-data">
                      {item?.order?.vendor?.name ?? "--"}
                    </td>
                    <td className="main-table-each-row-data">
                      {item?.verification_rejection_reason ?? "--"}
                    </td>
                    <td className="main-table-each-row-data d-flex align-items-center">
                      <span
                        className="text-danger fw_700 mx-1  text-nowrap cursor_pointer"
                        onClick={() => {
                          setOrderSelected(item?.order?.id);
                          setShowUploadInvoiceModal(true);
                        }}
                      >
                        UPLOAD INVOICE
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </TableContainer>
          {notificationData?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={notificationData?.pagination?.currentPage}
              totalPages={notificationData?.pagination?.totalPages}
              path={`/notification`}
              filters={`${queryString}`}
            />
          )}
        </div>
      </div>
    </main>
  );
};

export default Notification;
